<template>
  <div>
    <div
      class="SlcAppBar-left u-flex u-flexAlignItemsCenter"
      :class="{ 'is-mobile': $vuetify.breakpoint.xsOnly }"
    >
      <v-btn
        v-show="showBackArrow"
        @click.native="$emit('backButtonClick')"
        :style="{ color }"
        icon
        exact
      >
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-btn v-show="showMenu" icon @click.stop="$emit('menuButtonClick')">
        <v-icon>menu</v-icon>
      </v-btn>
      <v-toolbar-title v-if="title !== 'dpa select'" class="SlcAppBar-title">
        {{ $t(title) }}
      </v-toolbar-title>
      <template v-else>
        <img
          v-if="greyscaleLogo"
          src="../../../assets/logo-greyscale.svg"
          class="SlcAppBar-logo u-ml4 hidden-xs-only"
        />
        <img
          v-else
          src="../../../assets/logo.svg"
          class="SlcAppBar-logo u-ml4 hidden-xs-only"
        />
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    showBackArrow: {
      type: Boolean,
      required: false,
      default: false
    },
    showMenu: {
      type: Boolean,
      required: false,
      default: true
    },
    color: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    greyscaleLogo: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="postcss" scoped>
@import "suitcss-utils-flex";

/** @define SlcAppBar */

.SlcAppBar-left {
  width: calc(300px - 24px); /** magic number: left bar - left padding */
}

.SlcAppBar-left.is-mobile {
  width: 48px; /** magic number: menu button */
}

.SlcAppBar-left.is-mobile .SlcAppBar-title {
  overflow: initial;
}

.SlcAppBar-logo {
  width: 124px;
}
</style>
